// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toolbar[data-v-0cb56b92]{float:right;margin-top:30px}.toolbar svg[data-v-0cb56b92]{margin-left:20px;width:46px;height:46px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
